import * as Result from '$lib/utils/result';

export function keepNotNull<T>(list: readonly T[]): NonNullable<T>[] {
    return list.filter((e) => e != null);
}

export function keep<T>(
    list: readonly T[],
    predicate: (value: T, index: number, array: readonly T[]) => boolean,
): T[] {
    return list.filter(predicate);
}

export function keepNotEmptyString(list: readonly (string | null)[]): string[] {
    return list.filter((e) => e != null && e !== '') as string[];
}

export function keepIsOk<T>(list: readonly Result.Result<T, unknown>[]): T[] {
    return keepNotNull(
        list.map((res) => {
            if (Result.isOk(res)) {
                return res.data;
            } else {
                return null;
            }
        }),
    );
}

export function keepIsFailure<E>(list: readonly Result.Result<unknown, E>[]): E[] {
    return keepNotNull(
        list.map((res) => {
            if (Result.isFailure(res)) {
                return res.error;
            } else {
                return null;
            }
        }),
    );
}

export const filterNotNull = keepNotNull;
export const filterNotEmptyString = keepNotEmptyString;

export function reject<T>(
    list: readonly T[],
    predicate: (value: T, index: number, array: readonly T[]) => boolean,
): T[] {
    return list.filter((value, index, array) => {
        return !predicate(value, index, array);
    });
}
